import {
    GET_ALL_PROJECT_BASED_JOB,
    GET_SPECIFIC_PROJECT_BASED_JOB,
    CREATE_NEW_PROJECT_BASED_JOB,
    REMOVE_PROJECT_BASED_JOB,
} from '../actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    data_list: [],
    currentData: null,
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ALL_PROJECT_BASED_JOB: {
            return {
                ...state,
                data_list: action.payload?.result?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.result.current_page),
                    total: parseInt(action.payload.result.total),
                    perPage: parseInt(action.payload.result.per_page),
                }
            }
        }
        case GET_SPECIFIC_PROJECT_BASED_JOB: {
            return { ...state, currentData: action.payload }
        }
        // case CREATE_NEW_PROJECT_BASED_JOB: {
        //     return { ...state, data_list: [action.payload, ...state.data_list], total: state.total + 1 }
        // }
        // case UPDATE_SPECIFIC_PROJECT_BASED_JOB: {
        //     let index = state.data_list.findIndex((data) => {
        //         return data.id == action.payload.id;
        //     });
        //     let temp = [...state.data_list];
        //     temp[index] = action.payload;
        //     return { ...state, data_list: temp }
        // }
        case REMOVE_PROJECT_BASED_JOB: {
            let temp = state.data_list.filter(data => {
                return action.payload.indexOf(data.id) < 0;
            });
            return { ...state, data_list: temp }
        }
        default: return { ...state };
    }
}
